import {useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import ModuleBoardBoda2Dlg from '@/pages/MainPage/dialogs/ModuleBoardBoda2Dlg.jsx'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode, prjId, subTypeCode, sVer} = map.data

    if (! (
        'SA_MAP' === mapTypeCode &&
        'BODA2' === subTypeCode
    )) {
        return null
    }

    const onClick = () => openModal(
        <ModuleBoardBoda2Dlg
            prjId={prjId}
            sVer={sVer}
        />
    )

    return {
        label: '模件看板',
        onClick,
    }
}
